import {exists} from "./wvn_exist";

var menuMobile = {
  init : function (elementHtmlTag, className) {
    _menuMobilePrivate.open(elementHtmlTag.nextElementSibling, elementHtmlTag, className,'close');

    /*
    * Add event
    * */
    elementHtmlTag.nextElementSibling.addEventListener('click', function (e) {
      _menuMobilePrivate.open(e.currentTarget, elementHtmlTag, className);
    });
  },
};

var _menuMobilePrivate = {
  open : function (expandButtonElement, menuElementToOpen, className, forceState) {
    /*
     * Check if valid variable
     * */
    if (!exists(expandButtonElement)) {
      return;
    }

    /*
     * Expand or not ?
     *
     * if variable forceState exists and 'open' => Expand it !
     * if variable forceState exists and 'close' => Close it !
     * if variable forceState does exist => Toggle
     * */
    if (exists(forceState)
      && (forceState == 'open' || forceState == 'close')
    ) {
      var expandIt = forceState == 'open';
    }
    else {
      var expandIt = menuElementToOpen.classList.contains('menu-close');
    }

    /*
    * Do it !
    * */
    menuElementToOpen.classList.remove(expandIt ? 'menu-close' : 'menu-open');
    menuElementToOpen.classList.add(expandIt ? 'menu-open' : 'menu-close');

    /*
    * Avoid scrolling when menu is opened
    * */
    document.querySelector('body').classList.remove(expandIt ? 'oh-0' : 'oh-1');
    document.querySelector('body').classList.add(expandIt ? 'oh-1' : 'oh-0');
  }
};

export default menuMobile;
